import Swiper from 'swiper/bundle';

export default function gallery() {
  /**
   * Carousel
   */
  $('.wp-block-gallery.is-style-carousel').each(function () {
    // Swiper
    const $swiper = $(this).find('.swiper-container');
    const swiper = new Swiper($swiper.get(0), {
      spaceBetween: 100,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoHeight: true,
      loop: true,
      allowTouchMove: true,
      shortSwipes: false,
      simulateTouch: false,
      navigation: {
        nextEl: $swiper.find('.swiper-next').get(0),
        prevEl: $swiper.find('.swiper-prev').get(0),
      },
    });

    // Galery infos
    const $columns = $(this).closest('.wp-block-columns');
    if ($columns.length) {
      const $infos = $columns.find('.is-style-galery-infos');
      if ($infos.length) {
        $infos.clone().prependTo($swiper.find('.swiper-nav'));
      }
    }
  });
}
